// frontend/src/stores/lca.js
import { defineStore } from 'pinia';
import axios from 'axios';

export const useLCAStore = defineStore('lca', {
  persist: true,
  state: () => ({
    lcaData: {
      lifecycleStage: '',
      selectedSolution: null,
      selectedProvider: null,
      solutions: [],         // solutions for LCA steps
      productDetails: null,  // matched product from DB for LCI
      providerCompanies: [], // loaded providers for the chosen solution

      // Environmental impact data
      environmentalImpacts: null,

      // Transport result (distance, co2, etc.)
      transportResult: null,
      reuseHumanCalculations: null,
    },
    productNotFound: false,

    // Loading states
    isLoadingProviders: false,
    isLoadingImpacts: false,
  }),

  actions: {
    setLifecycleStage(stage) {
      this.lcaData.lifecycleStage = stage;
    },
    setSolutions(solutions) {
      // Erlaubte Kategorien definieren
      //const allowedCategories = ['reuse (human)', 'reuse (byproduct)'];
      const allowedCategories = ['reuse (human)'];
  
      // Lösungen filtern, die in den erlaubten Kategorien sind
      this.lcaData.solutions = solutions.filter(sol => 
        sol.solution_category &&
        allowedCategories.includes(sol.solution_category.toLowerCase())
      );
    },
    setSelectedSolution(solution) {
      this.lcaData.selectedSolution = solution;
    },
    setSelectedProvider(provider) {
      this.lcaData.selectedProvider = provider;
    },
    setTransportResult(result) {
      this.lcaData.transportResult = result;
    },

    async fetchProductByName(productName) {
      try {
        if (!productName || productName.trim() === '') {
          this.lcaData.productDetails = null;
          this.productNotFound = false;
          return;
        }
        const resp = await axios.get(`/products/by_name/${encodeURIComponent(productName)}`);
        if (resp.data.found) {
          this.lcaData.productDetails = resp.data;
          this.productNotFound = false;
        } else {
          this.lcaData.productDetails = null;
          this.productNotFound = true;
        }
      } catch (error) {
        console.error('Error fetching product by name:', error);
        this.lcaData.productDetails = null;
        this.productNotFound = true;
      }
    },

    async fetchProviderCompanies(solutionId) {
      this.isLoadingProviders = true;
      this.lcaData.providerCompanies = [];
      try {
        const resp = await axios.get(`/provider_companies?solution_id=${encodeURIComponent(solutionId)}`);
        if (resp.data.provider_companies) {
          this.lcaData.providerCompanies = resp.data.provider_companies;
        } else {
          this.lcaData.providerCompanies = [];
        }
      } catch (error) {
        console.error('Error fetching provider companies:', error);
        this.lcaData.providerCompanies = [];
      } finally {
        this.isLoadingProviders = false;
      }
    },

    async fetchEnvironmentalImpacts(productId) {
      this.isLoadingImpacts = true;
      this.lcaData.environmentalImpacts = null;
      try {
        const resp = await axios.get(`/environmental_impacts?product_id=${encodeURIComponent(productId)}`);
        if (resp.data.found) {
          this.lcaData.environmentalImpacts = resp.data.impacts;
        } else {
          this.lcaData.environmentalImpacts = null;
        }
      } catch (error) {
        console.error('Error loading environmental impacts:', error);
        this.lcaData.environmentalImpacts = null;
      } finally {
        this.isLoadingImpacts = false;
      }
    },
    
    // Reset entire store to initial state
    resetStore() {
      this.lcaData = {
        lifecycleStage: '',
        selectedSolution: null,
        selectedProvider: null,
        solutions: [],
        productDetails: null,
        providerCompanies: [],
        environmentalImpacts: null,
        transportResult: null,
        reuseHumanCalculations: null,
      };
      
      this.productNotFound = false;
      this.isLoadingProviders = false;
      this.isLoadingImpacts = false;
      
      console.log("LCA store has been reset to initial state");
    },
    setReuseHumanCalculations(calculations) {
      if (!calculations) {
        this.lcaData.reuseHumanCalculations = null;
        return;
      }
      this.lcaData.reuseHumanCalculations = calculations;
    },
  },
});
